import React from 'react'

import { Button, Form } from '_zari/core'

const ClearInputGroup = ({ id, iValue, clickClear, append }) => {
  const uniqueIdentifier = React.useMemo(() => {
    return `readonly-${id}`
  }, [id])

  return (
    <Form.InputGroup>
      <Form.InputText
        disabled
        id={uniqueIdentifier}
        name={uniqueIdentifier}
        tabIndex={-1}
        placeholder={iValue}
      />
      <Form.InputGroup.Append>
        <Button onClick={clickClear}>&#120;</Button>
      </Form.InputGroup.Append>
      {append && <Form.InputGroup.Append>{append}</Form.InputGroup.Append>}
    </Form.InputGroup>
  )
}

export default React.memo(ClearInputGroup)
